import { c as _c } from "react/compiler-runtime";
import { TEST_IDS } from '@repo/sdk/constants';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, Skeleton, useCommandState } from '@repo/ui/components';
import { Plus } from '@repo/ui/icons';
import { Suspense } from 'react';
import { CompanyResultRow } from './company-result-row';
import { toCompanyResult } from './company-search-result';
import { useSuspenseGetSearchCompanies } from './use-suspense-get-companies';
interface CompanyCommandProps {
  /** Focuses the search on mount; on by default. */
  autoFocus?: boolean;
  className?: string;
  disabled?: boolean;
  onCreateCompany?: () => void;
  onSelect: (value: {
    id: number;
    title: string;
  }) => void;
  orgIdOverride?: number;
}
const CompanyCommandSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="space-y-2 p-2" data-sentry-component="CompanyCommandSkeleton" data-sentry-source-file="company-command.tsx">{Array.from({
        length: 5
      }).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const CompanyCommandContent = t0 => {
  const $ = _c(10);
  const {
    onCreateCompany,
    onSelect,
    orgIdOverride
  } = t0;
  const search = useCommandState(_temp2);
  const {
    data
  } = useSuspenseGetSearchCompanies(search, orgIdOverride);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CommandEmpty data-sentry-element="CommandEmpty" data-sentry-source-file="company-command.tsx">No results found.</CommandEmpty>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== data.data?.length || $[2] !== onCreateCompany) {
    t2 = !data.data?.length && onCreateCompany && <CommandItem className="flex items-center gap-2" onSelect={() => onCreateCompany()}><Plus /> New company</CommandItem>;
    $[1] = data.data?.length;
    $[2] = onCreateCompany;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data.data || $[5] !== onSelect) {
    t3 = data?.data?.map(company => <CommandItem key={company.id} onSelect={() => onSelect(company)} value={company.title}><CompanyResultRow company={toCompanyResult(company)} /></CommandItem>);
    $[4] = data.data;
    $[5] = onSelect;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <>{t1}<div className="max-h-96 overflow-y-auto"><CommandList data-sentry-element="CommandList" data-sentry-source-file="company-command.tsx"><CommandGroup data-sentry-element="CommandGroup" data-sentry-source-file="company-command.tsx">{t2}{t3}</CommandGroup></CommandList></div></>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export const CompanyCommand = t0 => {
  const $ = _c(12);
  const {
    autoFocus: t1,
    className,
    disabled,
    onCreateCompany,
    onSelect,
    orgIdOverride
  } = t0;
  const autoFocus = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== autoFocus || $[1] !== disabled) {
    t2 = <CommandInput autoFocus={autoFocus} data-testid={TEST_IDS.company.commandInput} disabled={disabled} placeholder="Search company" data-sentry-element="CommandInput" data-sentry-source-file="company-command.tsx" />;
    $[0] = autoFocus;
    $[1] = disabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CompanyCommandSkeleton />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onCreateCompany || $[5] !== onSelect || $[6] !== orgIdOverride) {
    t4 = <Suspense fallback={t3} data-sentry-element="Suspense" data-sentry-source-file="company-command.tsx"><CompanyCommandContent onCreateCompany={onCreateCompany} onSelect={onSelect} orgIdOverride={orgIdOverride} data-sentry-element="CompanyCommandContent" data-sentry-source-file="company-command.tsx" /></Suspense>;
    $[4] = onCreateCompany;
    $[5] = onSelect;
    $[6] = orgIdOverride;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== className || $[9] !== t2 || $[10] !== t4) {
    t5 = <Command shouldFilter={false} data-sentry-element="Command" data-sentry-component="CompanyCommand" data-sentry-source-file="company-command.tsx"><div className={className}>{t2}{t4}</div></Command>;
    $[8] = className;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
function _temp(_, i) {
  return <Skeleton className="h-6 w-full" key={i} />;
}
function _temp2(state) {
  return state.search;
}